export const EMBEDDED_EVENTS = {
  DASHBOARD_LOADED: 'dashboard:loaded',
  DASHBOARD_RUN_START: 'dashboard:run:start',
  DASHBOARD_RUN_COMPLETE: 'dashboard:run:complete',
  DASHBOARD_DOWNLOAD: 'dashboard:download',
  DASHBOARD_TILE_DOWNLOAD: 'dashboard:tile:download',
  DASHBOARD_TILE_COMPLETE: 'dashboard:tile:complete',
} as const;

export const LOOKER_DOMAIN = 'https://looker.wolt.com';
